import React from "react";
import dariForm from "../hompage/image/dariForm.png";
import englishForm from "../hompage/image/englishForm.png";
import pashtoForm from "../hompage/image/pashtoForm.png";

const englishVersionLink =
  " https://forms.office.com/Pages/DesignPageV2.aspx?subpage=design&FormId=X2gZnfg7h0qk1LkZzwV1K12Xjxn4UdZPnMqvzcrlEctUMEQ0UFBHUTIxNDNFTlE2OERVRE5BODlHTS4u&Token=acf93e4f5b1c4e3caf5ce7822c854728";

const dariVersionLink =
  " https://forms.office.com/Pages/DesignPageV2.aspx?subpage=design&FormId=X2gZnfg7h0qk1LkZzwV1K12Xjxn4UdZPnMqvzcrlEctUQ1o1R1ZNVUtTMkpGMVgyQTBKOE85TEJYUy4u&Token=aca2847651ee48e1b634abbba3848c4b";

const pashtoVersionLink =
  " https://forms.office.com/Pages/DesignPageV2.aspx?subpage=design&FormId=X2gZnfg7h0qk1LkZzwV1K12Xjxn4UdZPnMqvzcrlEctUOTlXMTgyRDVZSldFWTdKUE5aMDEzQ1JGVi4u&Token=459238318343402180c87def07ade261";

function FeedbackCard() {
  return (
    <div className="mx-auto max-w-5xl w-full min-h-screen p-6">
      <div className="max-w-5xl w-full bg-white rounded-lg shadow-lg overflow-hidden lg:flex lg:space-x-12">
        {/* Card Content */}
        <div className="p-6">
          <h2 className="text-2xl text-center font-bold text-gray-800 mb-4">
            If you wish to share any feedback, concern or complaint with PoMA,
            please use any of the below links
          </h2>

          {/* Cards with Images */}
          <div className="flex lg:flex-row gap-7 flex-col space-y-10 lg:space-y-0 justify-center">
            <div className=" w-full bg-white rounded-lg shadow-md">
              <a href={dariVersionLink} rel="noreferrer" target="_blank">
                <img
                  className="w-full h-48 lg:h-64 object-cover object-top rounded-t-lg"
                  src={dariForm}
                  alt="Dari Form"
                />
              </a>
              <div className="p-2 text-center">Dari Form</div>
            </div>
            <div className=" w-full bg-white rounded-lg shadow-md">
              <a href={pashtoVersionLink} rel="noreferrer" target="_blank">
                <img
                  className="w-full h-48 lg:h-64 object-cover object-top rounded-t-lg"
                  src={pashtoForm}
                  alt="Pashto Form"
                />
              </a>
              <div className="p-2 text-center">Pashto Form</div>
            </div>
            <div className=" w-full bg-white rounded-lg shadow-md">
              <a href={englishVersionLink} rel="noreferrer" target="_blank">
                <img
                  className="w-full h-48 lg:h-64 object-cover object-top rounded-t-lg"
                  src={englishForm}
                  alt="english form"
                />
              </a>
              <div className="p-2 text-center">English Form</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FeedbackCard;

